var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('hd',{staticClass:"header"}),_vm._v("\n  1111\n  "),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('router-view')],1),_vm._v(" "),(_vm.mobiletype)?_c('mobilefooter'):_c('ft',{staticClass:"ft"}),_vm._v(" "),_c('GlobalDialogs')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638d4380","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = null
// module chunks = 